module.exports = __webpack_public_path__ + "static/ro_internationalization-8fd1ef39b60cd33e851c9e073a86b540.png";